import React, { useContext, useState } from "react";
import { Card, Collapse } from "react-bootstrap";
import { CollapsibleCardColorContext } from "../../utils/CollapsibleCardColorContext";
import useIsMobile from "../../utils/useIsMobile";
import "./CollapsibleCard.css"; // optional for the rotation animation

const CollapsibleCard = ({
  title,
  summary,
  className,
  children,
  initialOpen = true,
  isBulkEdit = false,
  dataTestId,
  id,
  menu,
  isWrapper = false,
}: {
  title: React.ReactNode;
  summary?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
  initialOpen?: boolean;
  isBulkEdit?: boolean;
  dataTestId?: string;
  id?: string;
  menu?: React.ReactNode;
  isWrapper?: boolean;
}) => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(initialOpen && !isMobile);
  const colorContext = useContext(CollapsibleCardColorContext);

  if (isBulkEdit) {
    return (
      <Card className={className} id={id}>
        <Card.Header>
          <div className="d-flex align-items-center w-100 justify-content-between">
            <strong>{title}</strong>
            {menu && (
              <div
                className="card-menu"
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the click from toggling the collapse
                }}
              >
                {menu}
              </div>
            )}
          </div>
        </Card.Header>
        <Card.Body>{children}</Card.Body>
      </Card>
    );
  }

  return (
    <Card className={className} id={id}>
      <Card.Header
        className="d-flex justify-content-between align-items-center"
        style={{
          cursor: "pointer",
          borderBottom: open ? undefined : "none",
          backgroundColor: colorContext?.color,
        }}
        onClick={() => setOpen(!open)}
        aria-controls="collapse-card-body"
        aria-expanded={open}
      >
        <div className="d-flex align-items-center w-100 justify-content-between">
          <span>
            <span
              className={`chevron ${open ? "open" : ""}`}
              style={{ marginRight: "0.5rem" }}
            >
              &rsaquo;
            </span>
            <strong data-testid={dataTestId}>{title}</strong>
            {summary && <strong> - {summary}</strong>}
          </span>
          {menu && (
            <div
              className="card-menu"
              onClick={(e) => {
                e.stopPropagation(); // Prevents the click from toggling the collapse
              }}
            >
              {menu}
            </div>
          )}
        </div>
      </Card.Header>
      <Collapse in={open}>
        <div id="collapse-card-body">
          <Card.Body
            style={{
              marginTop: isWrapper ? "-0.5rem" : undefined,
              padding: isWrapper ? "8px" : undefined,
            }}
          >
            {children}
          </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
};

export default CollapsibleCard;
